<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-form
        class="border-dashed"
      >
        <b-row>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(StudentList.DC_TYPE))"
              :label-for="StudentList.DC_TYPE"
            >
              <v-select
                :id="StudentList.DC_TYPE"
                v-model="filters[StudentList.DC_TYPE]"
                multiple
                :reduce="(option) => option.id"
                :options="dcTypes"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(StudentList.STATUS))"
              :label-for="StudentList.STATUS"
            >
              <v-select
                :id="StudentList.STATUS"
                v-model="filters[StudentList.STATUS]"
                :reduce="(option) => option.id"
                :options="studentStatues"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="directions.length"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(StudentList.DIRECTION))"
              :label-for="StudentList.DIRECTION"
            >
              <v-select
                :id="StudentList.DIRECTION"
                v-model="filters[StudentList.DIRECTION]"
                :reduce="(option) => option.id"
                :options="directions"
                :get-option-label="(option) => option.code + ' - ' + $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="4"
          >
            <b-form-group
              v-if="periods.length > 0"
              :label="$t(filterClass.getLabel(StudentList.PERIOD))"
              :label-for="StudentList.PERIOD"
            >
              <v-select
                id="period"
                v-model="filters[StudentList.PERIOD]"
                :options="periods"
                :get-option-label="(option) => option.admission_year + '-' + option.name"
                :placeholder="$t('All')"
                @input="selectQuarter"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="filters[StudentList.PERIOD]"
            md="4"
          >
            <b-form-group
              :label="$t(filterClass.getLabel(StudentList.QUARTER))"
              :label-for="StudentList.QUARTER"
            >
              <v-select
                :id="StudentList.QUARTER"
                v-model="filters[StudentList.QUARTER]"
                :reduce="(option) => option.id"
                :options="filters[StudentList.PERIOD].quarters"
                :get-option-label="(option) => option.quarter"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(StudentList.GENDER))"
              :label-for="StudentList.GENDER"
            >
              <v-select
                :id="StudentList.GENDER"
                v-model="filters[StudentList.GENDER]"
                :reduce="(option) => option.id"
                :options="genders"
                :get-option-label="(option) => $langName(option.name)"
                :placeholder="$t('All')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              class="mr-1"
              variant="success"
              @click="onFilter"
            >
              <feather-icon icon="LFilterIcon" />
              {{ $t('Filter') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </transition>
</template>

<script>
import vSelect from 'vue-select'
import {
  BButton, BCol, BForm, BFormGroup, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { isObject } from '@core/utils/utils'
import store from '@/store'
import StudentList from '@/views/components/filters/service/StudentList'

export default {
  name: 'FilterComponent',
  components: {
    BForm,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      period: null,
    }
  },
  computed: {
    StudentList() {
      return StudentList
    },
    dcTypes() {
      return this.$store.state.staticModule.dcTypes
    },
    directions() {
      return this.$store.state.staticModule.directionList
    },
    genders() {
      return this.$store.state.staticModule.genders
    },
    scholarshipStatus() {
      return this.$store.state.staticModule.scholarshipStatuses
    },
    periods() {
      return this.$store.state.period.periods
    },
  },
  watch: {
    periods(newValue) {
      this.changeValue(newValue, StudentList.PERIOD)
      if (this.filters[StudentList.PERIOD]?.quarters) this.changeValue(this.filters[StudentList.PERIOD].quarters, StudentList.QUARTER)
    },
    directions(newValue) {
      this.changeValue(newValue, StudentList.DIRECTION)
    },
  },
  created() {
    this.changeValue(this.studentStatues, StudentList.STATUS)
    this.changeValue(this.genders, StudentList.GENDER)
    if (Array.isArray(this.filters[StudentList.DC_TYPE])) {
      this.filters[StudentList.DC_TYPE] = this.filters[StudentList.DC_TYPE].map(x => Number(x))
    }
    if (this.filters[StudentList.ORGANIZATION]) {
      this.selectDirections(this.filters[StudentList.ORGANIZATION])
    }
  },
  methods: {
    selectDirections(id) {
      if (id) {
        this.$store.dispatch('staticModule/directionList', { org_id: id })
      } else {
        this.$store.commit('staticModule/SET_DIRECTION_LIST', [])
      }
    },
    selectQuarter() {
      this.filters[StudentList.QUARTER] = null
    },
    onFilter() {
      this.$emit('onFilter', this.filter)
    },
    onGenerateExel() {
      this.$emit('onGenerateExel', this.filter, StudentList.EXEL_GENERATE_ENDPOINT)
    },
    changeValue(newValue, field) {
      if (newValue.length && !isObject(this.filters[field])) {
        this.filters[field] = newValue.find(x => `${x.id}` === this.filters[field])
      }
    },
  },
  setup() {
    const studentStatues = store.getters['staticModule/getStudentStatuses']()
    return {
      studentStatues,
    }
  },
}
</script>

<style scoped>

</style>
